import firstPlacePrizeImg from '../../assets/new-year/1st-place-prize.png'
import secondPlacePrizeImg from '../../assets/new-year/2nd-place-prize.png'
import thirdPlacePrizeImg from '../../assets/new-year/3rd-place-prize.png'
import otherPlacesPrizeImg from '../../assets/new-year/other-places-prize.png'

export const newYearPrizes = [
  {
    label: '100 000 ₽',
    img: firstPlacePrizeImg,
  },
  {
    label: '50 000 ₽',
    img: secondPlacePrizeImg,
  },
  {
    label: '25 000 ₽',
    img: thirdPlacePrizeImg,
  },
  {
    label: '1 000 ₽',
    img: otherPlacesPrizeImg,
  },
]

export const newYearPrizesWithResult = [
  {
    label: '100 000 ₽',
    description: '+7 915 XXX-95-50',
    img: firstPlacePrizeImg,
  },
  {
    label: '50 000 ₽',
    description: '+7 903 XXX-47-61',
    img: secondPlacePrizeImg,
  },
  {
    label: '25 000 ₽',
    description: '+7 916 XXX-33-00',
    img: thirdPlacePrizeImg,
  },
]
